"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconKeyTopicsAndTargets = function IconKeyTopicsAndTargets(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m23.872 14.324 10.32-10.332.827 9.078 9.079.828-10.332 10.32-7.749-.697-5.18 5.176-1.414-1.414 5.152-5.148zm9.141 7.818-5.152-.463 6.651-6.647 5.15.469zm-.425-13.715.477 5.224-6.649 6.643-.469-5.218zm-.864 4.406-.708-.706-3.82 3.83.708.706zm-9.602-.036-.341-.038-.34-.03A15.16 15.16 0 1 0 35.44 27.84v-.599l-.01-.386a7 7 0 0 0-.083-.772l-1.974.316.037.281q.03.28.03.561v.6l-.004.321A13.16 13.16 0 1 1 21.88 14.783zm-1.198 6.779a8.29 8.29 0 1 0 7.656 8.264 8 8 0 0 0-.125-1.405l-1.97.35.052.35q.043.352.043.707A6.29 6.29 0 0 1 14 27.84a6.29 6.29 0 0 1 6.29-6.29q.356 0 .71.043l.24-1.986z",
    clipRule: "evenodd"
  })));
};

export { IconKeyTopicsAndTargets, IconKeyTopicsAndTargets as default };
